// extracted by mini-css-extract-plugin
export default {"title":"ResetPasswordSent_title__dv2du","description":"ResetPasswordSent_description__U52Z2","button":"ResetPasswordSent_button__ARpz6"};